import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { queryClient } from "@/lib/query-client";
import { CustomerAuthProvider } from "@/lib/auth/customer-auth-context";
import { AdminAuthProvider } from "@/lib/auth/admin-auth-context";
import { router } from "@/router";

/**
 * Racine applicative. Ordre des providers : TanStack Query (données) au-dessus
 * des deux contextes d'auth UI-only (customer/admin, cf. src/lib/auth/*),
 * eux-mêmes au-dessus du routeur — un composant de page peut ainsi utiliser
 * `useCustomerAuth()`/`useAdminAuth()` ET `useQuery()` sans se soucier de
 * l'ordre de montage.
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CustomerAuthProvider>
        <AdminAuthProvider>
          <RouterProvider router={router} />
        </AdminAuthProvider>
      </CustomerAuthProvider>
    </QueryClientProvider>
  );
}
